import { Component, AfterViewInit, Renderer2, Inject, OnInit } from '@angular/core';
import { AuthenticationService,EmployeesService, ProfileService, AlertService,CompanyService } from '../../_services/index';
import { environment } from '../../../environments/environment';
import { FormBuilder, FormsModule } from '@angular/forms';
import * as Prism from 'prismjs';
import {Router, ActivatedRoute} from "@angular/router"
import { DOCUMENT } from '@angular/platform-browser';
import { ThemeService } from 'ng2-charts';
import * as moment from 'moment'
@Component({
    selector: 'app-company',
    templateUrl: './employee.component.html',
    styleUrls: ['./employee.component.scss']
  })
  export class EmployeeComponent implements OnInit {
    public authorized:any;
    public lastDiseases:any;
    public user:any;
    public roles:any;
    public diseases:any;
    public employee:any;
    public idDiseases:any;
    public a:any;
    BirthDate:Date;
    constructor(
        public as: AuthenticationService,
        public alertService:AlertService,
        public companyService:CompanyService,
        public employeesService:EmployeesService,
        public profileService: ProfileService,
        private route: ActivatedRoute,
        private router: Router,
        @Inject(DOCUMENT) private _document,
    ){
        this.authorized = this.as.checkAuthentication();
        if(!this.authorized.authorized){
            this.router.navigate(['/login'])
        }
    }

    ngOnInit() {
        this.profileService.cast.subscribe(response => {
            this.user = response;
        }, error => {
        })
        this.employeesService.getDiseaseList().subscribe(response => {
            this.diseases = response;
            if (this.route.snapshot.params && this.route.snapshot.params.token) {
                this.getEmployee(this.route.snapshot.params.token)
            }else{
                this.employee = {
                    firstName: "",
                    lastName: "",
                    birthday: "",
                    employeeCode: "",
                    dpi: "",
                    email: "",
                    weight: "",
                    sex: "",
                    ocupation: "",
                    role: "employee",
                    diseases:[]
                }
            }
        }, error => {
        })
    }
    saveDiseases(item,type){
        if(this.employee.diseases.length > 0){
            if(this.route.snapshot.params && this.route.snapshot.params.token){
                for (let ii = 0; ii < this.employee.Diseases.length; ii++) {
                    if(this.employee.diseases[ii].id == item.id){
                        if(type == 'last'){
                            this.employee.diseases[ii] == item; 
                        }
                        return
                    }else if(this.employee.diseases.length == ii+1){
                        this.employee.diseases.push(item)
                    }
                }
            }else{
                for (let ii = 0; ii < this.employee.diseases.length; ii++) {
                    if(this.employee.diseases[ii].id == item.id){
                        if(type == 'last'){
                            this.employee.diseases[ii] == item; 
                        }
                        return
                    }else if(this.employee.diseases.length == ii+1){
                        this.employee.diseases.push(item)
                    }
                }
            }
        }else{
            this.employee.diseases.push(item)  
        }
    }
    changeValue(data){
        this.employee.diseases = [];
        data.forEach(select => {
            if(this.lastDiseases){
                this.lastDiseases.forEach(diseases => {
                    if(diseases.deleted){
                        diseases.deleted = false;
                    }
                    if(select == diseases.id){
                        this.saveDiseases(diseases,'last');
                    }
                });
            }
            this.diseases.forEach(diseases => {
                if(select == diseases.id){
                    this.saveDiseases(diseases,'list');
                }
            });
            
        });
    }
    getEmployee(data){
        this.employeesService.getEmployeeOne(data).subscribe(response => {
            this.employee = response;
            this.employee.birthday = moment(this.employee.birthday).format('YYYY-MM-DD');
            this.lastDiseases = this.employee.Diseases;
            this.idDiseases = []
            this.employee.Diseases.forEach(dis => {
                this.idDiseases.push(dis.id)
            });
            if(!response){
                this.alert({reason:'No se ha podido cargar el empleado.', type:"danger"});
                this.router.navigate(['/empleados']);
            }
        }, error => {
            this.alert({reason:'No se ha podido cargar el empleado.', type:"danger"});
            this.router.navigate(['/empleados']);
        })
    }
    delete(){
        this.employeesService.deleteEmployeeOne(this.employee).subscribe(response => {
            this.alert({reason:'El empleado ha sido eliminado con éxito.', type:"success"});
            this.router.navigate(['/empleados']);
        }, error => {
            this.alert({reason:'El empleado no ha sido eliminada, intentalo nuevamente.', type:"danger"});
        })
    }
    getSave(){
        if(this.route.snapshot.params && this.route.snapshot.params.token){
            this.changeValue(this.idDiseases);
            this.lastDiseases.forEach(last => {
                for (let iii = 0; iii < this.employee.diseases.length; iii++) {
                    if(this.employee.diseases[iii].id == last.id){
                        return
                    }else if(this.employee.diseases.length == iii+1){
                        last.deleted = true;
                        this.saveDiseases(last,'last');
                    }
                }
            });
            this.employeesService.updateEmployeeOne(this.employee).subscribe(response => {
                this.alert({reason:'El empleado ha sido actualizado con éxito.', type:"success"});
                this.router.navigate(['/empleados']);
            }, error => {
                this.alert({reason:'El empleado no ha sido actualizado, intentalo nuevamente.', type:"danger"});
            })
        }else{
            this.employeesService.newEmployeeOne(this.employee).subscribe(response => {
                this.alert({reason:'El empleado ha sido creado con éxito.', type:"success"});
                this.router.navigate(['/empleados']);
            }, error => {
                this.alert({reason:'El empleado no ha sido creado, intentalo nuevamente.', type:"danger"});
            })
        }
    }
    alert(data){
        this.alertService.updateAlert(data).subscribe(()=>{
            setTimeout(() => {
            this.alertService.deleteAlert().subscribe();
            }, 8000);
        })
    }
    
}


